/**
 * Synchronisation : les envois en attente de l'appareil, pour tout membre
 * (c'est sa propre file, lue sur l'appareil), et les conflits, arbitrés par qui
 * en a le droit (Q183) ; un texte se fusionne à la main sur sa page (FLD-9).
 */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';
import { SYNC_QUEUE_PATH } from './use-open-conflicts.js';

const ConflictsPage = lazy(() => import('./ConflictsPage.js').then((m) => ({ default: m.ConflictsPage })));
const ConflictMergePage = lazy(() => import('./ConflictMergePage.js').then((m) => ({ default: m.ConflictMergePage })));
const SyncQueuePage = lazy(() => import('./SyncQueuePage.js').then((m) => ({ default: m.SyncQueuePage })));

export const syncRoutes: AppRoute[] = [
  { path: '/conflits', element: <ConflictsPage />, gate: { anyOf: ['conflict.arbitrate'] } },
  { path: '/conflits/:id/fusion', element: <ConflictMergePage />, gate: { anyOf: ['conflict.arbitrate'] } },
  { path: SYNC_QUEUE_PATH, element: <SyncQueuePage /> },
];
